import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from './Dropdown';
import { NativeDropdown } from './NativeDropdown';

/**
 * Use `DynamicDropdown` to more easily switch between `Dropdown` and `NativeDropdown` using the `useNative` prop.
 *
 * Use the `MenuItem` component for each available option.
 *
 * Related components: [MenuItem](#menuitem), [ListItemText](#listitemtext), [Dropdown](#dropdown),
 * [NativeDropdown](#nativedropdown)
 *
 * Usage:
 *
 * ```jsx
 * import { DynamicDropdown } from '@one-thd/sui-atomic-components';
 * ```
 */
const DynamicDropdown = ({ children, useNative = false, ...other }) => {
  const Component = useNative ? NativeDropdown : Dropdown;

  return (
    <Component {...other}>
      {children}
    </Component>
  );
};

DynamicDropdown.displayName = 'DynamicDropdown';

DynamicDropdown.propTypes = {
  /**
   * A list of `MenuItem` elements to populate the dropdown with.
   */
  children: PropTypes.node.isRequired,
  /**
   * If true, will use `NativeDropdown` otherwise `Dropdown` will be used.
   */
  useNative: PropTypes.bool,
};

export { DynamicDropdown };
